import React from "react";

const CatWalkMalletteOutline = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='238.45'
      height='546.107'
      fillRule='nonzero'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit='10'
      clipRule='evenodd'
      version='1.1'
      viewBox='0 0 238.45 546.107'
      xmlSpace='preserve'
      className='clickable'
    >
      <g transform='translate(-762.25 -250.5)'>
        <path
          fill='rgba(0,0,0,0)'
          className='object-glow'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='5'
          d='M898.1 255.5c-11.667 2.333-21.467 5.6-29.4 9.8-7.933 4.2-13.067 7.7-15.4 10.5s-4.2 4.2-5.6 4.2c-1.4 0-3.967 1.867-7.7 5.6-3.733 3.733-5.6 6.3-5.6 7.7 0 1.4.7 4.667 2.1 9.8 1.4 5.133 3.5 9.333 6.3 12.6 2.8 3.267 7.467 5.367 14 6.3 6.533.933 13.767-.233 21.7-3.5s13.533-4.9 16.8-4.9c3.267 0 7 1.167 11.2 3.5 4.2 2.333 9.333 4.2 15.4 5.6 6.067 1.4 14 2.1 23.8 2.1s18.667-.933 26.6-2.8c7.933-1.867 14.233-4.9 18.9-9.1 4.667-4.2 7-7.467 7-9.8v-3.5h-7c-4.667 0-11.2-1.167-19.6-3.5-8.4-2.333-15.167-9.8-20.3-22.4-5.133-12.6-12.367-19.367-21.7-20.3-9.333-.933-19.833-.233-31.5 2.1z'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='5'
          d='M865.2 393.4c0 4.667-1.167 9.1-3.5 13.3-2.333 4.2-3.733 8.633-4.2 13.3-.467 4.667-2.333 8.867-5.6 12.6-3.267 3.733-7 6.767-11.2 9.1-4.2 2.333-11.2 11.667-21 28s-19.133 49.933-28 100.8S777.933 658 777 680.4c-.933 22.4-2.333 36.867-4.2 43.4-1.867 6.533-3.967 19.133-6.3 37.8-2.333 18.667-2.333 28.7 0 30.1 2.333 1.4 4.667 1.867 7 1.4 2.333-.467 3.733-.233 4.2.7.467.933 43.475-3.6 91.3-3.8 47.825-.2 99.533 6.733 100 3 .467-3.733 4.233-22.533-.9-49.6s-8.4-49-9.8-65.8c-1.4-16.8-2.1-27.767-2.1-32.9 0-5.133.467-7.933 1.4-8.4.933-.467.933-4.2 0-11.2-.933-7-.233-10.733 2.1-11.2 2.333-.467 3.5-5.133 3.5-14s-1.4-16.1-4.2-21.7c-2.8-5.6-5.6-9.1-8.4-10.5-2.8-1.4-3.967-3.033-3.5-4.9.467-1.867 1.167-3.267 2.1-4.2.933-.933 2.333-.933 4.2 0l2.8 1.4.7-2.8c.467-1.867.7-10.5.7-25.9 0-15.4-.933-24.733-2.8-28-1.867-3.267-2.8-6.533-2.8-9.8 0-3.267 2.8-10.033 8.4-20.3 5.6-10.267 7.933-15.867 7-16.8-.933-.933-1.167-2.8-.7-5.6.467-2.8-1.867-5.133-7-7s-7.7-3.733-7.7-5.6c0-1.867-3.733-5.6-11.2-11.2-7.467-5.6-15.167-9.8-23.1-12.6-7.933-2.8-18.667-8.167-32.2-16.1l-20.3-11.9v7z'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M798 541s-3.272 43.727-3.258 46.162c.038 6.695.408 13.047 1.345 19.695 1.308 9.268-1.353 19.379 6.492 26.663 5.413 5.027 13.136 5.652 20.08 5.395C824.095 638.862 839 635 839 635'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1'
          d='M876 436s-1.475 2.247-2 5c-.398 2.09.15 4.574 0 6'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1'
          d='M884 456c-1.025-.655-7.111-8.251-10-9-3.145-.815-13.033 1.637-14 2'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M833.064 610.202c-.566-.362 3.079-2.572 3.737-3.025 2.333-1.609 4.912-3.212 6.847-5.296 4.091-4.406 8.162-13.908 15.068-14.549 2.44-.227 4.834 1.466 7.068 1.701'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M864.888 592.357c.637-6.057 6.977-7.234 11.402-4.406.675.431 4.71 2.049 4.71 2.049'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M872 597c4-4 14.585-11.004 27-14 12.415-2.996 15-1 15-1'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M902.79 581.715c.006-.057 7.102-5.502 7.893-6.143 8.254-6.681 23.867-16.505 34.393-9.78'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M917.534 571.181c3.247 0 6.415 2.115 9.109 3.731 4.261 2.557 8.478 4.806 10.205 9.986a55.168 55.168 0 012.085 8.45c.142.853.22 1.878.22 2.743v.878'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M938.714 608.052c-.081.401-.104.815-.22 1.208-.157.529-2.737 6.506-2.195 6.913.637.478 2.971-.11 3.731-.11 3.832 0 7.371-1.21 11.194-1.756 1.272-.181 2.681-.185 3.95-.439.498-.099 1.983-.783 1.866-.548'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M828 631c15 10 69.695-2.067 71.357-1.962 8.144.512 14.594-4.562 21.461-7.933 2.527-1.24 4.995-2.322 7.689-3.036.936-.248 1.8-.643 2.759-.897.326-.086 1.655-.355 1.147-.387'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M861.502 428.671c-.376.098 1.11.341 1.48.419 1.004.214 2.36.711 3.316 1.123 2.708 1.167 5.789 2.711 8.271 4.372 4.068 2.723 6.719 7.071 9.86 10.668.944 1.081 2.037 2.704 2.7 4.024.222.442.999 2.335.739 1.935'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M873.59 425.908c1.881-.325 26.89 16.88 28.41 18.092 3.966 3.162 23.646 18.791 25 24'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M948.492 433.586c-.017.022 1.309 3.3 1.306 4.092-.012 3.789-.254 7.814-1.658 11.479-4.43 11.569-14.357 21.531-15.119 34.516-.321 5.459 4.636 9.693 5.555 14.747.931 5.116.271 10.264.255 15.357-.008 2.423-.551 4.784.107 7.224 1.132 4.203 2.357 9.044 4.35 12.926 2.066 4.027 1.823 9.908 2.615 14.262.507 2.785 2.454 7.304 1.893 10.064'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M867 395c9 6 20.639 12.99 31 19 4.732 2.745 19.48 7.342 26 11 11.252 6.313 23.074 16.306 25 17'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M885.115 525.904c-.511 7.722-3.674 19.37 5.132 22.715 6.314 2.398 12.652 4.748 19.083 6.814 13.339 4.286 24.442-7.706 35.717-12.404'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M893.106 524.547C906.899 524.795 939 522 939 522'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1'
          d='M904.257 528.148L939 526'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M885 544v44'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1'
          d='M888 548l.059 39.11'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M891.877 461.785c-.214-.429-.112 1.034-.091 1.284.066.8.183 1.576.183 2.384 0 2.357.006 4.71-.092 7.061-.315 7.567-.889 14.796-2.934 22.101-3.453 12.331-10.343 23.58-15.59 35.122-4.024 8.854-4.006 18.869-6.327 28.154'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M875.554 526.344c-.554 1.108.437 3.213.55 4.402.403 4.227.518 8.496.734 12.747.376 7.402.367 14.78.367 22.192 0 7.59.826 13.597-3.205 20.315'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M795.282 641.183c-4.97 34.61-10.301 69.17-14.909 103.83-2.087 15.697-3.706 31.56-3.302 47.39'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1'
          d='M797 653c-4.97 34.61-8.302 56.95-12.91 91.61-2.086 15.697-3.705 31.56-3.301 47.39'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M850 789c-2.468-45.918-.17-91.904-2.317-137.908'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1'
          d='M854 789.908c-2.468-45.918-.17-91.904-2.317-137.908'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M869 672c.026 6.157-3.928 16 1.546 18.819 24.401 12.567 48.678 10.6 71.34-4.41 4.872-3.227-1.199-11.766-3.303-17.217'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M891.298 671.344l46.994-2.932'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1'
          d='M908.628 673.134L939 672'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1'
          d='M869 675l9.888-.448'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M869 672l14.668-.625'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M871 692c-.292 2.029 3.131 58.038 5.488 59.908 6.392 5.073 15.531 2.457 22.792 2.225 3.832-.122 7.561.136 11.397-.113 6.768-.438 20.484 1.453 25.272-4.071 4.558-5.259 3.254-14.386 2.983-20.757-.446-10.46-2.781-36.689-2.418-39.216'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M874.835 692.861c-.292 2.029 2.984 57.201 5.342 59.071 6.391 5.073 15.53 2.457 22.791 2.225 3.832-.122 7.561.136 11.397-.113 6.768-.438 20.484 1.453 25.272-4.071 4.558-5.259 3.255-14.386 2.983-20.757C942.174 718.756 940 691 940 688'
          opacity='1'
        ></path>
        <path
          fill='#ff5c97'
          fillRule='nonzero'
          stroke='none'
          d='M933.663 258.164c-.206 1.102-.457 1.699-.753 1.794-.296.094-.416.257-.362.489.055.232-.359.709-1.241 1.431-.883.722-1.718 1.593-2.506 2.611-.788 1.018-1.346 2.337-1.675 3.957-.328 1.619-.412 3.133-.251 4.539.16 1.407.589 2.603 1.287 3.589.697.987 1.587 1.854 2.67 2.603 1.082.748 1.759 1.127 2.03 1.137.272.009.493.581.662 1.716.17 1.135.346 1.779.529 1.932.183.153.612-.156 1.287-.928.675-.771 1.049-1.312 1.123-1.623.073-.311.705-.436 1.895-.373 1.19.062 2.332-.024 3.428-.258a10.01 10.01 0 003.182-1.301c1.026-.633 1.757-1.528 2.195-2.684.437-1.156.752-1.793.944-1.912.193-.119.504-.045.934.221l.645.398.22-.933c.147-.622.317-.993.509-1.112.193-.118.6-.104 1.222.043s1.042.109 1.259-.113c.217-.223.095-.635-.365-1.236-.46-.602-1.172-1.181-2.135-1.737-.964-.556-1.501-1.641-1.613-3.255-.111-1.614-.508-2.831-1.19-3.649-.683-.818-1.526-1.538-2.529-2.158-1.003-.62-2.386-1.139-4.149-1.556-1.763-.416-3-.627-3.711-.63-.711-.004-1.148-.354-1.312-1.05l-.247-1.043-.444.141c-.296.094-.511-.039-.644-.399l-.201-.54-.193.119c-.128.079-.295.669-.5 1.77zm3.515 3.542l1.007-.091c.672-.06 1.526.032 2.563.277 1.037.245 1.901.641 2.594 1.188.692.547 1.065.936 1.12 1.168.054.232-.279.482-.999.75s-1.948-.214-3.682-1.445l-2.603-1.847zm-5.184 3.866l.348-.082.204 2.266c.135 1.51-.162 2.535-.891 3.074l-1.095.809-.04-1.57a7.319 7.319 0 01.544-2.992c.388-.949.698-1.45.93-1.505zm5.043.206l.467.111c.311.073.573.354.786.843.213.488.127.851-.257 1.089-.385.237-.649.312-.792.223-.144-.089-.213-.488-.21-1.199l.006-1.067zm-6.177 8.067l.984-.342.984-.342.136 1.51.136 1.51-1.12-1.168-1.12-1.168zm8.643-3.213c1.441-.536 2.67-.409 3.689.379l1.527 1.182-.843.786c-.562.525-.847.923-.857 1.194-.009.272-.367.625-1.072 1.061-.705.435-1.637.79-2.797 1.063-1.16.274-1.843.386-2.051.337-.207-.049-.358-.222-.452-.518-.095-.296.048-.782.427-1.459a3.32 3.32 0 00.418-2.119c-.099-.735.571-1.371 2.011-1.906z'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1'
          d='M897 313s17-3.5 32-10 28-16 28-16'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1'
          d='M835 293s29.5-4.5 52-14 38-24 38-24'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M940 447a2 2 0 113.999-.001A2 2 0 01940 447z'
          opacity='1'
        ></path>
        <path
          fill='rgba(0,0,0,0)'
          stroke='#ff5c97'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M958 453a2 2 0 113.999-.001A2 2 0 01958 453z'
          opacity='1'
        ></path>
      </g>
    </svg>
  );
}

export default CatWalkMalletteOutline;
